import { useState, type ReactNode } from "react";

export function Section({
  title,
  count,
  defaultOpen = true,
  accent,
  children,
}: {
  title: string;
  count?: number | string;
  defaultOpen?: boolean;
  accent?: "default" | "warn" | "ok" | "risk";
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const dot =
    accent === "warn"
      ? "bg-warn"
      : accent === "ok"
        ? "bg-ok"
        : accent === "risk"
          ? "bg-risk"
          : "bg-accent";
  return (
    <section className="mt-3">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-1 mb-2"
      >
        <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
        <h2 className="text-2xs uppercase tracking-[0.18em] font-semibold text-zinc-400">
          {title}
        </h2>
        {count != null && (
          <span className="text-2xs text-zinc-500 tabular">{count}</span>
        )}
        <span className="ml-auto text-zinc-600 text-xs tabular">
          {open ? "−" : "+"}
        </span>
      </button>
      {open && children}
    </section>
  );
}
